module.exports = __webpack_public_path__ + "img/ed-back.8f18bcc5.png";